import React from "react";

const InsightDashboard = () => {
  return (
    <div className="tw-w-full tw-bg-white dark:tw-bg-black tw-px-6 sm:tw-px-6 tw-py-6 tw-rounded-2xl tw-shadow-sm">
      <h3 className="tw-text-lg tw-font-semibold dark:tw-text-white">
        Mood Insights
      </h3>
      <p className="tw-text-gray-500 tw-mt-2">Coming soon</p>
    </div>
  );
};

export default InsightDashboard;
